<template>
  <section id="hero" class="hero section dark-background">
    <div
      id="hero-carousel"
      class="carousel slide carousel-fade"
      data-bs-ride="carousel"
      data-bs-interval="5000"
    >
      <!-- Carousel Items -->
      <div
        v-for="(consel, index) in conselhos"
        :key="consel.id"
        :class="['carousel-item', { active: index === 0 }]"
      >
        <img
          :src="apiEndpoint + '/storage/conselhopratico/' + consel.imagem"
          class="d-block w-100"
          id="homefoto"
          :alt="consel.imagem"
        />

        <div class="carousel-container">
          <h2>{{ $content(consel.titulo) }}</h2>
           <p v-if="consel.descricao">
            {{ $content(consel.descricao).substring(0, 250) }} ...
          </p>
        </div>
      </div>

      <!-- Controles -->
      <a
        class="carousel-control-prev"
        href="#hero-carousel"
        role="button"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">{{ $t('common.previous') }}</span>
      </a>
      <a
        class="carousel-control-next"
        href="#hero-carousel"
        role="button"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">{{ $t('common.next') }}</span>
      </a>

      <!-- Indicadores -->
    </div>
  </section>

  <br />
  <div class="page-title light-background">
    <div class="container d-lg-flex justify-content-between align-items-center">
      <h1 id="bread" class="mb-2 mb-lg-0">{{ $t('home.latestNews') }}</h1>
    </div>
  </div>

  <br />
  <!-- GRID ULTIMAS NOTICIAS -->
  <section id="memes-grid" class="memes-grid section">
    <div class="container">
      <div class="row gy-4">
        <div
          v-for="(event, index) in filteredList"
          :key="index"
          class="col-lg-3 col-md-4 col-sm-6"
        >
          <div class="meme-card">
            <img
              :src="apiEndpoint + '/storage/capanoticia/' + event.imagem"
              :alt="event.imagem"
            />
            <div class="meme-info">
              <a href="#" @click.prevent="openModal(event)">
                <h3>{{ $content(event.titulo).substring(0, 80) }}</h3>
              </a>
              <a href="#" @click.prevent="openModal(event)">
                <span><i class="bi bi-book"></i> {{ $t('common.readMore') }}</span>
                <IconAwe class="icon-color" icon="arrow-right" />
              </a>
              <!--
                         <router-link
                :to="{ name: 'eventview', params: { id: event.id } }"
              >
                <span><i class="bi bi-book"></i> Ler mais </span>
               </router-link>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- GRID VIDEOS -->

  <br />
  <div class="page-title light-background">
    <div class="container d-lg-flex justify-content-between align-items-center">
      <h1 id="bread" class="mb-2 mb-lg-0">{{ $t('home.video') }}</h1>
    </div>
  </div>
  <section id="videos-grid" class="videos-grid section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="video-wrapper">
            <iframe
              src="https://www.youtube.com/embed/FfOy6YfNtKY"
              :title="$t('home.videoPlayer')"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="linha-gradiente"></div>
  <br />
  <section id="imagens-grid" class="imagens-grid section">
    <div class="container">
      <div class="row">
        <!-- Coluna 1 - Proponente -->
        <div class="col-lg-4 col-md-6 col-sm-12 mb-4 text-center">
          <p><b id="orangestyle">{{ $t('home.proponent') }}</b></p>
          <div class="imagens-wrapper">
            <img
              src="assets/img/team/unicv.png"
              class="central-image44"
              :alt="$content(&quot;Imagem 1&quot;)"
            />
          </div>
        </div>

        <!-- Coluna 2 - Parceiros -->
        <div class="col-lg-4 col-md-6 col-sm-12 mb-4 text-center">
          <p><b id="orangestyle">{{ $t('footer.partners') }}</b></p>
          <div class="imagens-wrapper">
            <img
              src="assets/img/team/han.png"
              class="central-image4"
              :alt="$content(&quot;Imagem 4&quot;)"
            />
            <img
              src="assets/img/team/LOGO MEDICINA[2].png"
              class="central-image2"
              :alt="$content(&quot;Imagem 5&quot;)"
            />
            <img
              src="assets/img/team/hcm.png"
              class="central-image"
              :alt="$content(&quot;Imagem 6&quot;)"
            />
          </div>
        </div>

        <!-- Coluna 3 - Financiadores -->
        <div class="col-lg-4 col-md-6 col-sm-12 mb-4 text-center">
          <p><b id="orangestyle">{{ $t('home.funders') }}</b></p>
          <div class="imagens-wrapper">
            <img
              src="assets/img/team/calouste.png"
              class="central-image3"
              :alt="$content(&quot;Imagem 7&quot;)"
            />
            <img
              src="assets/img/team/lacaixa.png"
              class="central-image5"
              :alt="$content(&quot;Imagem 8&quot;)"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Modal -->
   <div
    class="modal fade"
    id="noticiaModal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <!-- <h5 class="modal-title">{{ $content(selectedNoticia?.titulo) }}</h5>-->
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            :aria-label="$t('common.close')"
          ></button>
        </div>
        <div class="modal-body">
          <img
            v-if="selectedNoticia"
            :src="
              apiEndpoint + '/storage/capanoticia/' + selectedNoticia.imagem
            "
            class="img-fluid mb-3"
            :alt="$content(selectedNoticia.titulo)"
          />
          <h5 class="modal-title">{{ $content(selectedNoticia?.titulo) }}</h5>
          <br />
          <p id="pmiodo">
            <strong>{{ $t('common.author') }}</strong> {{ selectedNoticia?.autor }}
          </p>
          <p id="pmiodo">
            <strong>{{ $t('common.published') }}</strong> {{ $formatDate(selectedNoticia?.created_at) }}
          </p>
           <p v-html="formattedConteudo"></p>


         </div>

        <br />
        <div class="modal-footer d-flex justify-content-between">
          <!-- Botões de redes sociais -->
          <div class="social-buttons">
           <b> {{ $t('home.share') }}</b>
            <a
              :href="`https://www.facebook.com/sharer/sharer.php?u=${linkNoticia}`"
              target="_blank"
              class="btn btn-primary me-1"
              :title="$t('home.shareFacebook')"
            >
              <i class="bi bi-facebook"></i>
            </a>
            <a
              :href="`https://twitter.com/intent/tweet?url=${linkNoticia}&text=${selectedNoticia?.titulo}`"
              target="_blank"
              class="btn btn-info me-1"
              :title="$t('home.shareTwitter')"
            >
              <i class="bi bi-twitter"></i>
            </a>
            <a
              :href="`https://api.whatsapp.com/send?text=${selectedNoticia?.titulo} ${linkNoticia}`"
              target="_blank"
              class="btn btn-success me-1"
              :title="$t('home.shareWhatsApp')"
            >
              <i class="bi bi-whatsapp"></i>
            </a>
            <!-- Botão copiar link -->
            <a
              class="btn btn-outline-secondary"
              @click="copiarLink(selectedNoticia)"
            >
              <i class="bi bi-link-45deg"></i> {{ $t('common.copyLink') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Backdrop -->
  <div
    v-if="showModal"
    class="modal-backdrop fade show"
    @click="closeModal"
  ></div>
</template>

<script>
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import axios from "axios";
import { API_ENDPOINT } from "../main.js";
import * as bootstrap from "bootstrap";

export default {
  name: "HomeView",
  data: () => ({
    conselhos: [],
    noticias: [],
    currentSort: "titulo",
    currentSortDir: "asc",
    search: "",
    searchSelection: "",
    pageSize: 4,
    pageSizeConselhos: 4, // <--- adicionado
    currentPage: 1,
    apiEndpoint: API_ENDPOINT, //endpoint que vem direto do main.js se mudar para publico aqui tb muda
    selectedNoticia: null, // <- notícia selecionada para o modal
    showModal: false,
  }),
  methods: {
     
    copiarLink(noticia) {
      if (!noticia) return;

      const link = `${window.location.origin}/noticias?noticiaId=${noticia.id}`;
      navigator.clipboard.writeText(link);
    },
    openModal(event) {
      this.selectedNoticia = event;

      // Atualiza link para compartilhamento
      this.linkNoticia = encodeURIComponent(
        `${window.location.origin}/noticias?noticiaId=${event.id}`
      );

      let modal = new bootstrap.Modal(document.getElementById("noticiaModal"));
      modal.show();
    },
    /*openModal(noticia) {
      this.selectedNoticia = noticia;
      this.showModal = true;
    },*/
    closeModal() {
      this.showModal = false;
      this.selectedNoticia = null;
    },
  },

  computed: {
    formattedConteudo() {
      return this.$contentHtml(this.selectedNoticia?.conteudo);
    },
    conselhospraticos() {
      return this.conselhos
        .filter((data) => {
          return data.titulo.toLowerCase().includes(this.search.toLowerCase());
        })
        .filter((row, index) => {
          let start = (this.currentPage - 1) * this.pageSizeConselhos;
          let end = this.currentPage * this.pageSizeConselhos;
          return index >= start && index < end;
        });
    },
    filteredList() {
      return this.noticias
        .filter((data) => {
          return data.titulo.toLowerCase().includes(this.search.toLowerCase());
        })
        .filter((row, index) => {
          let start = (this.currentPage - 1) * this.pageSize;
          let end = this.currentPage * this.pageSize;
          return index >= start && index < end;
        });
    },
  },

  created() {
    axios
      .get(`${API_ENDPOINT}/api/ultimosEventos`)

      .then((response) => {
        this.noticias = response.data;
      });

    axios.get(`${API_ENDPOINT}/api/ultimosConselhos`).then((response) => {
      this.conselhos = response.data;
    });
    axios.get(`${API_ENDPOINT}/api/ultimaNoticia`).then((response) => {
      this.noticias = response.data;
    });
  },

  mounted() {
    axios
      .get(`${API_ENDPOINT}/api/ultimosConselhos`)
      .then((response) => {
        // Pega só os primeiros 5 memes para não carregar demais
        this.conselhos = response.data.data.conselhos.slice(0, 5);
      })
      .catch((error) => {
        console.error("Erro ao buscar Caroussel:", error);
      });
  },
};
</script>

<style scoped>
.central-image3{ 
  max-width: 200px;
  max-height: 100px;
  width: auto;
  height: auto;
  max-width: 35%;
}


h3 {
  font-family: "Times New Roman", Times, serif;
  font-size: 20px;
}

h2 {
  background: linear-gradient(
    to right,
    rgba(255, 165, 0, 0.55),
    rgba(13, 179, 198, 0.55)
  );
  color: white;
  padding: 10px 20px;
  border-radius: 6px;

  font-size: 35px;
}
h5 {
  color: #05b4c6;
  font-weight: bold;
}
h3:hover {
  color: #05b4c6;
}

.meme-info:hover {
  font-weight: bold;
}
 

</style>
